import { render, staticRenderFns } from "./AspireTeacherPrep2020.vue?vue&type=template&id=cd47c120&scoped=true"
import script from "./AspireTeacherPrep2020.vue?vue&type=script&lang=js"
export * from "./AspireTeacherPrep2020.vue?vue&type=script&lang=js"
import style0 from "./AspireTeacherPrep2020.vue?vue&type=style&index=0&id=cd47c120&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd47c120",
  null
  
)

export default component.exports